import Vue from "vue"
import Vuex from "vuex"
import http from "@/api/api"
import router from "@/router"
import carUpdate from "./modules/carUpdate"
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        isLogin: localStorage.getItem('isLogin') || false,
        userName: localStorage.getItem('userName') || "",
        imgSize: 3145728, // 图片上传大小限制
        fileSize: 5242880, // 文件大小限制
    },
    mutations: {
        login(state, data) {
            state.isLogin = true
            state.userName = data
            localStorage.setItem('isLogin', true)
            localStorage.setItem('userName', data)
        },
        logout(state) {
            state.isLogin = false
            localStorage.removeItem('isLogin')
            localStorage.removeItem('userName')
            localStorage.removeItem("token")
            localStorage.removeItem("refreshToken")
            console.log('asdas')
        }
    },
    actions: {
        getUserInfo(ctx, path) {
            console.log(path)
            http.getUserInfo().then(res => {
                if (res.data.code == 200 && res.data.success) {
                    let role = ""
                    if (localStorage.getItem('userInfo')) {
                        role = JSON.parse(localStorage.getItem('userInfo')).currentRole
                    }
                    localStorage.setItem("userInfo", JSON.stringify(res.data.data))
                    console.log(res.data.data)
                    ctx.commit("login", res.data.data.name || res.data.data.mobile)
                    // if (role == res.data.data.currentRole && path) {
                    if (path) {
                        router.push(path)
                    } else {
                        router.push('/')
                    }
                }
            })
        }
    },
    modules: {
        carUpdate
    },
})
export default store